import { api } from "@/configs/axios";

type MePendingCardsOutput = {
  count: number
}

type WinnersResponse = {
  value: number
  username: string
  phoneNumber: string
}

export type GetCardResponse = {
  id: string
  userId: string
  cardId: string
  hasUsed: boolean
  createdAt: string
  card: {
    drawBalls: number[],
    cardBalls: number[],
    id: string
    key: string
    sequential: string
    priceValue: number
  }
}

type PickForPurchaseResponse = {
  drawBalls: number[],
  cardBalls: number[]
  sequential: string
  id: string
  priceValue: number
  key: string
}

export type GetMeCardsResponse = {
  title: string
  cards: {
    id: string
    drawNumbers: number[],
    cardBalls: number[],
    value: number
    createdAt: string
    isWinner: boolean
    sequential: string
    key: string
  }[]
}

export class CardsService {

  async mePending() {
    const { data } = await api.get<MePendingCardsOutput>("/cards/count/me/pendings")

    return data.count
  }
  async winners() {
    const { data } = await api.get<WinnersResponse[]>("/cards/winners")

    return data
  }

  async getFirst() {
    const { data } = await api.get<GetCardResponse>("/cards/me/card")

    return data
  }

  async pickForPurchase() {
    const { data } = await api.get<PickForPurchaseResponse[]>("/cards/pick-for-purchase")

    return data
  }
  async update(id: string) {
    const { data } = await api.patch(`/cards/draw/${id}`)

    return data
  }

  async meCards(date?: Date) {
    const { data } = await api.get<GetMeCardsResponse[]>("/cards/me/cards", {
      params: {
        date
      }
    })

    return data
  }

  async drawCard(id: string) {
    await api.put(`/cards/me/draw/${id}`)
  }

  async getToDraw() {
    const { data } = await api.get<GetCardResponse>(`/cards/me/get-to-draw`)
    return data
  }

  async get(id: string) {
    const { data } = await api.get<PickForPurchaseResponse>(`/cards/card/${id}`)
    return data
  }
}

export const cardsServiceInstance = new CardsService()